
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, InputNumber, Button, message, Alert, DatePicker } from 'antd';
import { getAllStatus, getAllStatusUpdated, updateEquipmentLocation, updateTableLocation } from '../../Services/LocomotiveServices';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
const LocomotiveModal = ({ visible, onClose, onSubmit }) => {
    const [form] = Form.useForm();
    const [equipStatusOptions, setEquipStatusOptions] = useState([]);
    const [equipStatusLocation, setEquipStatusLocation] = useState([]);
    const handleCancel = () => {
        form.resetFields();
        onClose();
    };
    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                values.Loco_HP = parseFloat(values.Loco_HP);

                onSubmit(values);
                form.resetFields();
                message.success('Locomotive has been added successfully');
            })
            .catch((info) => {

            });
    };

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const statuses = await getAllStatusUpdated();
                setEquipStatusOptions(statuses?.data);
            } catch (error) {
                console.error('Error fetching statuses:', error);
                setEquipStatusOptions([]);
            }
        };

        if (visible) {
            fetchStatuses();
        }
    }, [visible]);


    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const result = await updateTableLocation();
                setEquipStatusLocation(result?.data);
            } catch (error) {
                console.error('Error fetching statuses:', error);
                setEquipStatusLocation([]);
            }
        };

        if (visible) {
            fetchLocation();
        }
    }, [visible]);

    const validateInput = (rule, value, callback) => {
        const pattern = /^[A-Za-z]+ \d+$/;
        // const regexPattern = /^[a-zA-Z]+\s?\d*$/;

        if (pattern.test(value)) {
            callback();
        } else {
            callback('Input must start with alphabets, have a space, and end with numbers.');
        }
    };

    const Unit_Type = ['Road', 'Switcher'];
    const Axle = [4, 6];

    return (


        <Modal
            visible={visible}
            title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Add Locomotive</span>}
            onCancel={handleCancel}
            onOk={handleOk}
            okText="Create"
            okButtonProps={{ style: { background: '#2963ad', color: '#fff' } }} // Change button color


        >



            <Form form={form}
                name="basic"
                labelCol={{
                    span: 7,
                }}
                wrapperCol={{
                    span: 16,
                }}
                style={{
                    maxWidth: 800,
                }}
                initialValues={{
                    remember: true,
                }}

                autoComplete="off"
                labelAlign='left'
            >
                <Form.Item
                    label="Equip ID"
                    name="EquipUID"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your EquipID!',
                        },
                        {
                            validator: validateInput,
                            message: 'Input must start with alphabets, have a space, and end with numbers.',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="Loco_Model"
                    label="Model"
                    rules={[{ required: true, message: 'Please enter Model!' }]}

                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="Unit_Type"
                    label="Locomotive Type"
                    rules={[{ required: true, message: 'Please select Locomotive Type!' }]}

                >
                    <Select placeholder="Select a Locomotive Type"
                    >
                        {Unit_Type.map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="Loco_HP"
                    label="Horsepower"
                    rules={[{ required: true, message: 'Please Enter Horsepower!' }]}

                >

                    <Input type='number' />
                </Form.Item>

                <Form.Item
                    name="Mfr_Year"
                    label="Year Built"
                    rules={[{ required: true, message: 'Please Enter Year Built!' }]}
                >
                    <DatePicker picker='year' style={{ width: "100%" }} disabledDate={current => current && current > moment().endOf('year')} />
                </Form.Item>

                <Form.Item
                    name="Axles"
                    label="Axles"
                    rules={[{ required: true, message: 'Please select Axles!' }]}

                >

                    <Select placeholder="Select a Axles"
                    >
                        {Axle.map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>

                </Form.Item>





                <Form.Item
                    name="EquipStatus"
                    label="Equip Status"
                    rules={[{ required: true, message: 'Please enter EquipStatus!' }]}

                >
                    <Select placeholder="Select Equip Status"
                    //  style={{marginLeft:'36px',width:'77%'}}
                    >

                        {equipStatusOptions?.map((status) => (
                            < Select.Option key={status.id} value={status.id} >
                                {status?.IS_Description}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="EquipLocation"
                    label="Location"
                    rules={[{ required: false, message: 'Please enter Location!' }]}

                >
                    <Select placeholder="Select Location"
                    //  style={{marginLeft:'36px',width:'77%'}}
                    >

                        {equipStatusLocation?.map((locate) => (
                            < Select.Option key={locate.id} value={locate.id} >
                                {/* {locate?.} */}
                                {locate?.title}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>




            </Form>

        </Modal >
    );
};

export default LocomotiveModal;

